<template>
  <div
    class="w-full rounded-lg py-2.5 px-3 flex items-start gap-x-2"
    :class="{
      'bg-red-300 text-white': type === 'error',
    }"
    role="alert"
  >
    <p class="text-sm"><slot /></p>
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    type?: "error";
  }>(),
  {
    type: "error",
  }
);
</script>
